import React from "react";

export default function PrivacyScoreView({ score = "High", description = "", onBack }) {
  const normalizedScore = score.charAt(0).toUpperCase() + score.slice(1).toLowerCase();

  return (
    <div style={{ backgroundColor: "#000", color: "#fff", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Sticky Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Privacy Information</h2>
      </div>

      {/* Scrollable Content */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "2rem 1.5rem",
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto",
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            backgroundColor: "#111",
            border: "1px solid #333",
            borderRadius: "8px",
            padding: "1rem 1.25rem",
            marginBottom: "2rem",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.1rem" }}>
            Privacy Score: {normalizedScore}
          </h3>
          <p style={{ color: "#ccc", fontSize: "0.95rem", lineHeight: 1.5 }}>{description}</p>
        </div>
      </div>
    </div>
  );
}